import {
  ButtonMediumPrimaryLeadingIcon,
  Icon,
} from "@studio3t/generic-components";
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { ListPageHeader } from "./ListPageHeader";

// Breadcrumb primitives live in the shared ListPageHeader now; re-export them so
// existing imports from "@/components/PipelinesHeader" keep working.
export {
  BreadcrumbCurrent,
  BreadcrumbCurrentGroup,
  BreadcrumbGroup,
  BreadcrumbLink,
  BreadcrumbSeparator,
  PipelineCrumbIcon,
} from "./ListPageHeader";

// Pipelines list / single-pipeline header. The title row ("Pipelines" + count)
// is shared by both screens; the list keeps Add pipeline as the title-row
// action, while a single pipeline swaps in its own (Download report), and the
// breadcrumb trail (with optional right-aligned actions) changes.
export function PipelinesHeader({
  count,
  breadcrumb,
  action,
  actions,
}: {
  count?: number;
  breadcrumb: ReactNode;
  /** Title-row action; defaults to Add pipeline. */
  action?: ReactNode;
  actions?: ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <ListPageHeader
      title="Pipelines"
      count={count}
      breadcrumb={breadcrumb}
      actions={actions}
      action={
        action ?? (
          <ButtonMediumPrimaryLeadingIcon
            text="Add pipeline"
            icon={Icon.Plus}
            onClick={() => navigate("/pipelines/new")}
          />
        )
      }
    />
  );
}
